import React from 'react';
import 'bootstrap/dist/js/bootstrap.min';

export default class GetAPIKeyContent extends React.Component {
    constructor(props){
        super(props);
    }
    render() {
        return(
            <div className = "col-sm-12">
                <div className="section-03 page-header" id="guides-section-03">
                    <h1 className="blog-title">Ticket Open API Key 발급받기</h1>
                </div>

                <div className="blog-post">
                    <h3 className="mt40">이 단계를 시작하시기전에 Join 카테고리에서 판매자 등록을 하셔야 합니다.</h3>
                    <p>이 장에서는 Production 환경에 사용될 API키를 발급하는 과정에 대하여 설명합니다.
                        Production Open API Key 신청후 key발급은 즉각적으로 이루어지나 실제 access 권한은 내부 심사절차에 의해 근무일 기준 24 ~ 72시간의
                        인증 시간을 필요로 하며 간혹 심사절차가 길어지는
                        경우도 있으니 이 Getting Started 문서에 따라서 진행하시는것을 추천합니다.
                    </p>
                </div>
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/apis/GetAPIKeyContent.jsx